// extracted by mini-css-extract-plugin
export default {"prop":"prop_node___prop___e20060b2","propValue":"prop_node___propValue___c318ba46"};